import Page from "@jumbo/shared/Page";
import AuthenticateAndRolesMiddleware from "../Middleware";
import AuthenticateMiddleware from "../Middleware/AuthenticateMiddleware";
import AddSample from "app/pages/SampleTracking/AddEdit";
import ListSamples from "app/pages/SampleTracking/List";

const routesName = "/dashboards/sampleTracking";
const modules = "sampleTracking";

export const sampleTrackingRoute = [
  {
    middleware: [
      {
        element: AuthenticateMiddleware,
        fallbackPath: {
          url: "/login",
        },
      },
    ],
    routes: [
      {
        middleware: [
          {
            element: AuthenticateAndRolesMiddleware,
            fallbackPath: {
              url: "/dashboard",
              module: "sampleTracking",
              role: "add",
            },
          },
        ],
        routes: [
          {
            path: `${routesName}`,
            element: <Page component={ListSamples} />,
          },
        ],
      },
      {
        middleware: [
          {
            element: AuthenticateAndRolesMiddleware,
            fallbackPath: {
              url: "/dashboard",
              module: "sampleTracking",
              role: "add",
            },
          },
        ],
        routes: [
          {
            path: `${routesName}/add`,
            element: <Page component={AddSample} />,
          },
        ],
      },
      {
        middleware: [
          {
            element: AuthenticateAndRolesMiddleware,
            fallbackPath: {
              url: "/dashboard",
              module: "sampleTracking",
              role: "edit",
            },
          },
        ],
        routes: [
          {
            path: `${routesName}/edit`,
            element: <Page component={AddSample} />,
          },
        ],
      },
    ],
  },
];
